import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('ccip_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('ccip_token');
      localStorage.removeItem('ccip_user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export const authAPI = {
  register: (data) => api.post('/auth/register', data),
  login: (data) => api.post('/auth/login', data),
  me: () => api.get('/auth/me'),
};

export const contractsAPI = {
  getAll: (params) => api.get('/contracts', { params }),
  getById: (id) => api.get(`/contracts/${id}`),
  create: (data) => api.post('/contracts', data),
  update: (id, data) => api.patch(`/contracts/${id}`, data),
  getExpiringSummary: (days) => api.get('/contracts/expiring/summary', { params: { days } }),
};

export const accountsAPI = {
  getAll: () => api.get('/accounts'),
  getById: (id) => api.get(`/accounts/${id}`),
  create: (data) => api.post('/accounts', data),
};

export const salesforceAPI = {
  getConfig: () => api.get('/salesforce/config'),
  createConfig: (data) => api.post('/salesforce/config', data),
  testConnection: () => api.post('/salesforce/test-connection'),
};

export const marketRatesAPI = {
  getAll: (params) => api.get('/market-rates', { params }),
  create: (data) => api.post('/market-rates', data),
  update: (id, price) => api.put(`/market-rates/${id}`, { price }),
};

export const usersAPI = {
  getAll: () => api.get('/users'),
};

export default api;
